import { useEffect, useState, createContext } from 'react'

import FooterContent from './FooterContent'
import Navigation from './Navigation'
import ButtonClube from '../ButtonClube/ButtonClube'

type NavigationContextType = {
  heightContainer: number | null
}

const NavigationContext = createContext<NavigationContextType>({
  heightContainer: null,
})

const headerMobileHeight = 129

interface MenuContentProps {
  setMenuIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

function MenuContent({ setMenuIsOpen }: MenuContentProps) {
  const [heightViewport, setHeightViewport] = useState(736)

  useEffect(() => {
    const setHeightContainer = () => {
      if (visualViewport) {
        setHeightViewport(visualViewport.height)
      }
    }

    setHeightContainer()

    visualViewport?.addEventListener('resize', setHeightContainer)

    return () =>
      visualViewport?.removeEventListener('resize', setHeightContainer)
  }, [])

  const heightContainer = heightViewport - headerMobileHeight

  return (
    <NavigationContext.Provider value={{ heightContainer }}>
      <article
        data-testid="menu-mobile"
        className="fixed top-0 h-[100vh] w-full z-10 bg-white border-t border-lightestBlue overflow-hidden max-h-[88%] !max-h-[100dvh]"
      >
        <div className="relative w-full h-full">
          <div className="flex flex-col overflow-y-auto overflow-x-hidden h-full w-full scrollbar-v2">
            <Navigation setMenuIsOpen={setMenuIsOpen} />
            <div className="mx-4 restructure-small-desktop:hidden block restructure-small-desktop:order-2 mb-7 restructure-small-desktop:mb-0 rounded-[88px] bg-[#E1E3F5] min-w-[225px]">
              <ButtonClube />
            </div>
            <FooterContent setMenuIsOpen={setMenuIsOpen} />
          </div>
        </div>
      </article>
    </NavigationContext.Provider>
  )
}

export default MenuContent
